var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "signup__form" },
    [
      _c(
        "div",
        { staticClass: "my-5", staticStyle: { "text-align": "center" } },
        [
          _vm.dtIsLoading
            ? _c("v-progress-linear", {
                attrs: { indeterminate: true, color: "primary", height: "3" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.dtIsValid
            ? _c("label", {
                staticClass: "primary--text",
                staticStyle: { "font-weight": "bold" },
                attrs: { for: "" },
                domProps: {
                  innerHTML: _vm._s(_vm.$t("LBL_NEW_EMAIL", _vm.dtInfo))
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "login--button",
          attrs: { color: "turquoise", block: "" },
          on: { click: _vm.handleGotoProfile }
        },
        [
          _c(
            "v-icon",
            {
              staticStyle: { "font-size": "20px" },
              attrs: { color: "primary" }
            },
            [_vm._v("icon-profile")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "login--button-text ml-2 primary--text" }, [
            _vm._v(_vm._s(_vm.$t(_vm.config.label)))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.dtError
        ? _c(
            "v-alert",
            {
              staticStyle: { "margin-top": "5%", width: "45vh" },
              attrs: {
                value: true,
                color: "error",
                icon: "warning",
                outline: ""
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.dtError.message) + "\n  ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-691fb4a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-691fb4a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/change-email-verification/template.html
// module id = null
// module chunks = 